// Dependencies
import styled, { css } from "styled-components";

type ContainerStyleProps = {
    color: string;
};

export const Container = styled.div<ContainerStyleProps>`
    .legend-item {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 0.75rem;
        font-weight: 400;

        letter-spacing: 0.01em;
        line-height: 1.333;

        .dot {
            display: inline-block;
            border-radius: 50%;
            width: 8px;
            height: 8px;
            margin-right: 0.347em;
        }

        ${({ color }) =>
            !!color &&
            css`
                .dot {
                    background-color: ${color};
                }

                .label,
                .value {
                    color: ${color};
                }
            `}
    }
`;
